





































































import { defineComponent, inject, ref, onMounted } from '@vue/composition-api'
import OutPutCard from '../components/OutPutCard.vue'
import Button from '../components/parts/Button.vue'
import { key } from '../store'

export default defineComponent({
  name: 'Result',
  components: {
    OutPutCard,
    Button,
  },
  setup() {
    const store = inject(key)
    const root = ref()
    let tableHeightRef = ref('')
    if (!store) {
      throw new Error('')
    }
    const blockImgs: { [key: string]: string } = {
      ヒト: '/img/pose_blocks/table_pose_human.png',
      ライオン: '/img/pose_blocks/table_pose_lion.png',
      トリ: '/img/pose_blocks/table_pose_bird.png',
      ウサギ: '/img/pose_blocks/table_pose_rabbit.png',
    }

    const calculateScore = (programPoses: string[], predictedPoses: string[]): number => {
      if (programPoses.length === 0 || predictedPoses.length === 0) {
        return 0
      }
      const maxScore = programPoses.length
      let score = 0
      for (let i = 0; i < maxScore; i++) {
        if (programPoses[i] === predictedPoses[i]) {
          score++
        }
      }
      return Math.ceil((score / maxScore) * 100)
    }

    const resizeTable = () => {
      if (root.value) {
        tableHeightRef.value = root.value.clientHeight - 48 - 16 - 16 + 'px'
      }
    }
    onMounted(() => resizeTable())

    return {
      store,
      tableHeightRef,
      root,
      resizeTable,
      score: (): number => calculateScore(store.state.outputs, store.state.predictedPoses),
      blockImgs,
    }
  },
})
